import { MyDatePicker as DatePicker } from './DatePicker';
export default DatePicker;
